
import { onMounted, nextTick, watch, ref, computed, onBeforeMount, reactive } from 'vue'
import { addWrongQuestion, cancelWrongQuestion, checkWrongQuestionStatus } from '@/api/index'
import { nativeToast, playVideo } from '@/utils/nativeFn'
import { queryVideoInfo } from '@/api/aio'
import { useRoute } from 'vue-router'
export default {
  name: 'QueAnalysisTile',
  props: {
    questionData: {
      type: Object,
      default: () => ({})
    },
    submitQestionMap: {
      type: Object,
      default: () => ({})
    },
    questionIndex: {
      type: Number,
      default: 0
    },
    currentIndex: {
      type: Number,
      default: -1
    },
    xesEvent: {
      type: Function,
      default: () => {}
    }
  },
  emits: ['xesEvent'],
  setup(props, { emit }) {
    const loadedVedio = ref(false)
    const addedWrongStatusChecked = ref(false)

    const { source_location } = useRoute().query
    const isWeekStudy = computed(() => source_location === 'itembank')

    const addedWrong = ref(false)
    const queTypeDes = ref(props.questionData?.list?.logicQuesTypeName || '')
    const total = ref(props.questionData?.total || 0)
    const isRight = ref(props.questionData?.isRight)
    const queId = props.questionData?.list?.queId || ''
    const isAjaxing = ref(false)
    const playVideoParam = reactive({ content_id: '' })
    const videoImg = ref('')
    let clickedVideoPlay = false
    const preventDefaultEvent = () => {
      return false
    }
    const currentIndex = computed(() => {
      return props.currentIndex
    })
    const myAnswer = computed(() => {
      let _myAnswer = null
      if (props.questionData?.list?.childList?.length) {
        _myAnswer = props.questionData.list.childList.map((item) => {
          return props.submitQestionMap?.[item.queId]?.data || []
        })
      } else {
        _myAnswer = [[...(props.submitQestionMap?.[props.questionData?.list?.queId]?.data || [])]]
      }
      return _myAnswer
    })
    watch(currentIndex, (val) => {
      if (!loadedVedio.value && val >= 0 && val === props.questionIndex) {
        !isWeekStudy.value && checkQueStatus()
        getVideoInfo()
        loadedVedio.value = true
      }
    })
    onBeforeMount(() => {
      if (
        !loadedVedio.value &&
        currentIndex.value >= 0 &&
        currentIndex.value === props.questionIndex
      ) {
        checkQueStatus()
        getVideoInfo()
        loadedVedio.value = true
      }
    })

    onMounted(() => {
      window['TalqsInteraction'].toggleInteraction([
        {
          queId,
          rectifyState: [0]
        }
      ])
      renderQuestion()
    })
    // 渲染题目信息
    const renderQuestion = () => {
      let data = props.questionData
      let questionIndex = props.questionIndex
      nextTick(() => {
        let questionTitleDom: any = document.getElementById(
          `questionAanlysisiTitle_${questionIndex}`
        )
        let questionAnalysisDom: any = document.getElementById(`questionAnalysis_${questionIndex}`)
        let questionAnswerDom: any = document.getElementById(`questionAnswer_${questionIndex}`)
        try {
          questionTitleDom.innerHTML = (window as any).TalqsTemplate.render(data.list, {
            hideDifficulty: true,
            hideSource: true,
            hideCamera: true
          })

          questionAnalysisDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent(
            'questionAnalyze',
            data.list,
            {
              hideDifficulty: true,
              hideSource: true,
              hideCamera: true,
              analyzeVersion: 2
            }
          )
          questionAnswerDom.innerHTML = (window as any).TalqsTemplate.renderPartialComponent(
            'questionAnswer',
            data.list,
            {
              hideDifficulty: true,
              hideSource: true,
              hideCamera: true
            }
          )
          ;(window as any).MathJax.Hub.Queue([
            'Typeset',
            (window as any).MathJax.Hub,
            questionTitleDom
          ])
          ;(window as any).MathJax.Hub.Queue([
            'Typeset',
            (window as any).MathJax.Hub,
            questionAnalysisDom
          ])
          ;(window as any).MathJax.Hub.Queue([
            'Typeset',
            (window as any).MathJax.Hub,
            questionAnswerDom
          ])
          ;(window as any).MathJax.Hub.Queue([
            'Typeset',
            (window as any).MathJax.Hub,
            document.getElementById(`myAnswer_${questionIndex}`)
          ])
          ;(window as any).TalqsTemplate.autoLayout()
        } catch (e) {
          console.log('error', e)
        }
      })
    }

    // 加入错题本
    const addWrongList = (nry_question_id) => {
      if (isAjaxing.value) {
        return
      }
      let params = {
        nry_question_id
      }
      isAjaxing.value = true
      emit('xesEvent', { exer_status: 'add_into_notebook' })
      addWrongQuestion(params)
        .then((res) => {
          isAjaxing.value = false
          if (res.data.code !== 0 && res.data.code !== 100901) {
            nativeToast(res.data.message)
            return
          }
          addedWrong.value = true
          nativeToast('已加入错题本')
        })
        .catch((err) => {
          isAjaxing.value = false
          console.log(err)
        })
    }
    // 移出错题本
    const cancelWrongList = (nry_question_id) => {
      if (isAjaxing.value) {
        return
      }
      let params = {
        nry_question_id
      }
      isAjaxing.value = true
      emit('xesEvent', { exer_status: 'remove_notebook' })
      cancelWrongQuestion(params)
        .then((res) => {
          isAjaxing.value = false
          if (res.data.code !== 0 && res.data.code !== 100902) {
            nativeToast(res.data.message)
            return
          }
          addedWrong.value = false
          nativeToast('已移出错题本')
        })
        .catch((err) => {
          isAjaxing.value = false
          console.log(err)
        })
    }
    // 根据题目id查询题目是否已加入错题本
    const checkQueStatus = () => {
      checkWrongQuestionStatus({ nry_question_id: queId })
        .then((res) => {
          if (res.data.code === 0) {
            addedWrong.value = !!res.data?.data?.is_wrong_question
          }
          addedWrongStatusChecked.value = true
        })
        .catch((err) => {
          addedWrongStatusChecked.value = true
        })
    }
    const getVideoInfo = () => {
      queryVideoInfo({ nry_question_id: queId })
        .then((res) => {
          if (res.data.code == 0) {
            const data = res.data.data
            videoImg.value = data?.good_img || ''
            Object.assign(playVideoParam, {
              resource_vod_src: data.resource_vod_src,
              resource_src: data.resource_src,
              content_id: data.unionid,
              sn: data?.sn || '',
              source_list: data?.source_list || [],
              is_dot: data.is_dot,
              title: data.title
            })
          }
        })
        .catch((err) => {})
    }
    const doPlayVideo = () => {
      if (clickedVideoPlay) {
        return
      }
      clickedVideoPlay = true
      playVideo(playVideoParam, (res) => {
        console.log('视频播放中')
        clickedVideoPlay = false
      })
      emit('xesEvent', { play_vedio: 'play_vedio' })
      let timer = setTimeout(() => {
        clickedVideoPlay = false
        clearTimeout(timer)
      }, 300)
    }
    return {
      queTypeDes,
      total,
      queId,
      isRight,
      myAnswer,
      addedWrong,
      playVideoParam,
      videoImg,
      addedWrongStatusChecked,
      addWrongList,
      cancelWrongList,
      doPlayVideo,
      preventDefaultEvent,
      isWeekStudy
    }
  }
}
